import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Switch } from "@headlessui/vue";
import { CheckIcon, EllipsisHorizontalIcon } from "@heroicons/vue/24/outline";


export default /*#__PURE__*/_defineComponent({
  __name: 'OaiSwitch',
  props: /*#__PURE__*/_mergeModels({
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
}, {
    "modelValue": { type: Boolean },
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(["changed"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {

const model = _useModel<boolean>(__props, "modelValue");
const emit = __emit;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Switch), {
    modelValue: model.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      _cache[1] || (_cache[1] = ($event: any) => (emit('changed', $event)))
    ],
    class: _normalizeClass([
      model.value && !__props.disabled ? 'bg-green-600' : 'bg-gray-200',
      !__props.disabled ? 'cursor-pointer' : 'cursor-default',
      'relative inline-flex h-6 w-11 shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out',
    ]),
    disabled: __props.disabled
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass([
        model.value ? 'translate-x-5' : 'translate-x-0',
        'pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
      ])
      }, [
        _createElementVNode("span", {
          class: _normalizeClass([
          model.value ? 'opacity-0 duration-100 ease-out' : 'opacity-100 duration-200 ease-in',
          'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity',
        ]),
          "aria-hidden": "true"
        }, [
          _createVNode(_unref(EllipsisHorizontalIcon), { class: "h-3 w-3 text-gray-400" })
        ], 2),
        _createElementVNode("span", {
          class: _normalizeClass([
          model.value ? 'opacity-100 duration-200 ease-in' : 'opacity-0 duration-100 ease-out',
          'absolute inset-0 flex h-full w-full items-center justify-center transition-opacity',
        ]),
          "aria-hidden": "true"
        }, [
          _createVNode(_unref(CheckIcon), {
            class: _normalizeClass(["h-3 w-3", [__props.disabled ? 'text-gray-200' : 'text-green-600']])
          }, null, 8, ["class"])
        ], 2)
      ], 2)
    ]),
    _: 1
  }, 8, ["modelValue", "class", "disabled"]))
}
}

})